import React from 'react';
import { Button } from '@mui/material';
import { Row } from 'components/Layout';
import { dateToLabel } from 'further-ui/utils';

type Props = {
  certificate?: {
    adviserId: string;
    date: Date;
    url: string;
    adviser?: {
      _id: string;
      fullName: string;
    };
    investment?: {
      externalInvestmentId?: string;
      fund?: { fundName?: string };
      investmentDate?: Date;
    };
  };
};

const CertificateItem: React.FC<Props> = ({ certificate }) => {
  return (
    <Row spacing="sm" centered>
      <span>
        {certificate?.date ? dateToLabel(certificate?.date, '-', true) : ''} by{' '}
        {certificate?.adviser?.fullName}
        {certificate?.investment
          ? ` - (${
              certificate.investment.externalInvestmentId ??
              `${certificate.investment.fund?.fundName} - ${dateToLabel(
                certificate.investment.investmentDate,
              )}`
            })`
          : ''}
      </span>
      <Button
        size="extra-small"
        variant="outlined"
        color="primary"
        onClick={() => window.open(certificate?.url)}
      >
        Download document
      </Button>
    </Row>
  );
};

export default CertificateItem;
